<template>
  <div id="modalAlterarColigada" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Alterar Coligada</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="changeColigada">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12">
                <select class="form-select" v-model="v$.codColigada.$model">
                  <option value="" disabled>Selecione uma Coligada</option>
                  <option
                    v-for="empresa in empresas"
                    :key="empresa.codColigada"
                    :value="empresa.codColigada"
                    :title="`${empresa.codColigada} - ${empresa.nome}`"
                  >
                    {{ empresa.codColigada }} - {{ empresa.nome }}
                  </option>
                </select>
                <span
                  v-if="v$.codColigada.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              title="Alterar Coligada"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Alterar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import { mapGetters } from 'vuex'
import PATHS from '@/router/routesMap'

export default {
  name: 'AlterarColigadaModal',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      empresas: [],
      codColigada: '',
      disableButton: false,
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    async getEmpresas() {
      try {
        this.empresas = await this.$store.dispatch('getEmpresas')
        showModal('modalAlterarColigada')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }

        hideModal()
        this.$emit('closeModal', true)
      }
    },

    async changeColigada() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          await this.$store.dispatch('changeColigada', {
            codColigada: this.codColigada,
          })
          if (this.$route.path === PATHS.HOME) {
            window.location.reload()
          } else {
            this.$router.push(PATHS.HOME)
          }
        } catch (error) {
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        } finally {
          hideModal()
          this.$emit('closeModal', true)
        }
      }
    },
  },

  validations() {
    return {
      codColigada: {
        required,
      },
    }
  },

  mounted() {
    this.getEmpresas()
  },
}
</script>
